import React from "react";
import { Box } from "@mui/material";

const BoxedResponsiveText = ({ children, color = "#000", align = "center", sx = {} }) => {
  return (
    <Box
      sx={{
        textAlign: align,
        width: 'auto',
        fontSize: {
          xs: "0.8rem", 
          sm: "0.9rem",   
          md: "1rem", 
        },
        color: color,
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default BoxedResponsiveText;